interface BlogContent {
    highlights: string[];
    keyPoints: string[];
    conclusion: string[];
    references: string[];
}

export interface Blog {
    id: string;
    title: string;
     
    description: string;
    imageUrl: string;
    content: BlogContent;
    tags: string[];
    color: string;
}

export const blogs: Blog[] = [
    {
        id: "advances-liver-transplant",
        title: "Recent Advances in Liver Transplantation Techniques",
        
        
        description: "Exploring cutting-edge developments in liver transplantation procedures and post-operative care strategies.",
        imageUrl: "/images/liver-transplant.jpg",
        color: "#8a655e", // brown
        tags: ["Liver Transplant", "Surgery", "Medical Innovation"],
        content: {
            highlights: [
                "Implementation of machine perfusion technology",
                "Advances in immunosuppression protocols",
                "Minimally invasive surgical techniques",
                "Enhanced recovery protocols post-transplant"
            ],
            keyPoints: [
                "Improved organ preservation methods leading to better outcomes",
                "Novel immunosuppression strategies reducing rejection rates",
                "Integration of robotic assistance in transplant procedures",
                "Development of personalized medicine approaches"
            ],
            conclusion: [
                "Significant progress in transplant success rates",
                "Reduced post-operative complications",
                "Better quality of life for recipients"
            ],
            references: [
                "Journal of Hepatology 2024",
                "American Journal of Transplantation",
                "International Liver Transplantation Society Guidelines"
            ]
        }
    },
    {
        id: "gastrointestinal-oncology",
        title: "Understanding Modern Gastrointestinal Oncology",
       
        description: "A comprehensive overview of current approaches in gastrointestinal cancer treatment.",
        imageUrl: "/images/gastro-onco.jpg",
        color: "#ab8d6c", // earthybeige
        tags: ["Oncology", "GI Surgery", "Cancer Treatment"],
        content: {
            highlights: [
                "Latest surgical techniques in GI cancer",
                "Integration of targeted therapies",
                "Role of immunotherapy",
                "Minimally invasive approaches"
            ],
            keyPoints: [
                "Evolution of surgical techniques",
                "Importance of multidisciplinary approach",
                "Impact of genetic profiling",
                "Advances in post-operative care"
            ],
            conclusion: [
                "Improved survival rates with modern approaches",
                "Enhanced quality of life outcomes",
                "Importance of early detection"
            ],
            references: [
                "World Journal of Gastroenterology",
                "Surgical Oncology Reviews",
                "Clinical Cancer Research"
            ]
        }
    },
    {
        id: "laparoscopic-innovations",
        title: "Innovations in Laparoscopic Surgery",
 
        description: "Exploring the latest developments in minimally invasive surgical techniques.",
        imageUrl: "/images/lap-cholecystectomy.png",
        color: "#A1ADA5", // sage
        tags: ["Laparoscopy", "Minimally Invasive", "Surgical Innovation"],
        content: {
            highlights: [
                "3D visualization systems",
                "Advanced surgical instruments",
                "Robot-assisted procedures",
                "Improved recovery protocols"
            ],
            keyPoints: [
                "Benefits of minimally invasive approaches",
                "Technological advancements in instruments",
                "Patient outcomes and satisfaction",
                "Cost-effectiveness analysis"
            ],
            conclusion: [
                "Reduced recovery time",
                "Better cosmetic results",
                "Higher patient satisfaction rates"
            ],
            references: [
                "Surgical Endoscopy Journal",
                "Minimally Invasive Surgery",
                "Journal of Laparoendoscopic Surgery"
            ]
        }
    },
    {
        id: "pancreatic-surgery-advances",
        title: "Advanced Techniques in Pancreatic Surgery",
        
        description: "Latest developments and techniques in pancreatic surgery and treatment.",
        imageUrl: "/images/pancreatic-surgery.jpg",
        color: "#E2B949", // palegold
        tags: ["Pancreatic Surgery", "Surgical Techniques", "Innovation"],
        content: {
            highlights: [
                "Novel surgical approaches",
                "Enhanced imaging techniques",
                "Precision medicine applications",
                "Post-operative care improvements"
            ],
            keyPoints: [
                "Integration of artificial intelligence",
                "Advances in surgical planning",
                "Improved patient selection criteria",
                "Enhanced recovery protocols"
            ],
            conclusion: [
                "Better surgical outcomes",
                "Reduced complications",
                "Improved long-term survival"
            ],
            references: [
                "Pancreatic Surgery Journal",
                "HPB Surgery International",
                "Journal of Surgical Oncology"
            ]
        }
    }
];